import { Box, Text } from "@chakra-ui/react"

type DiscussionEmptyProps = {
  message: string
}

/**
 * React conversion of discussion-empty.js
 * Simple empty state component for when there are no responses
 *
 * Original Marionette view functionality:
 * - Displays a message when no responses exist
 * - Message varies based on user permissions (can_respond vs can't respond)
 */
function DiscussionEmpty({ message }: DiscussionEmptyProps) {
  return (
    <Box className="discussion-empty-view" py={4} w="full">
      <Text
        className="discussion-empty-message open-text-light"
        color="gray.500"
        fontSize="md"
        textAlign="center"
      >
        {message}
      </Text>
    </Box>
  )
}

export default DiscussionEmpty
